import { memo } from 'react';
import { Stack, Box, SxProps } from '@mui/material';
import { Theme } from '@mui/system';

interface IDialogBodyProps {
  children?: React.ReactNode;
  marginTop?: string;
  marginBottom?: string;
  style?: SxProps<Theme>;
  overflowY?: string;
  height?: string;
}

function DialogBody({ children, marginTop, marginBottom, style, overflowY, height }: IDialogBodyProps) {
  return (
    <Stack
      sx={{
        flex: 1,
        overflowY: overflowY || 'hidden',
        marginTop: marginTop || 0,
        marginBottom: marginBottom || 0,
      }}
    >
      <Box
        sx={
          {
            ...style,
            height: height || '100%',
            '@supports (overflow-y: overlay)': {
              overflowY: 'overlay',
            },
            '@supports not (overflow-y: overlay)': {
              overflowY: 'auto',
            },
          } as SxProps<Theme>
        }
      >
        {children}
      </Box>
    </Stack>
  );
}

export default memo(DialogBody);
